var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"instagram-icon",attrs:{"color":"white"},domProps:{"textContent":_vm._s('mdi-instagram')}})}
var staticRenderFns = []

export { render, staticRenderFns }